module.exports = __webpack_public_path__ + "img/symbol_8.bd356cfc.png";